import ApiGenericServicesData from "service/ApiGenericServicesData";

export default class ValidarOtp extends ApiGenericServicesData {
    constructor() {
        super("validacion_sms");
    }

    enviar(requestBody) {
        return this.customPOSTpublic("enviar", requestBody);
    }

    verificar(requestBody) {
        return this.customPOSTpublic("verificar", requestBody);
    }
}
